import { Control } from 'react-hook-form'

import { Box, Collapse, FormControlOptions } from '@chakra-ui/react'
import * as EmailValidator from 'email-validator'

import { FormInputSelectControl } from '@/components/ui'
import { OptionI } from '@/utils/forms/optionBuilders'

export interface EmailInputSelectControlIProps extends FormControlOptions {
  control: Control
  id: string
  isLoading: boolean
  isOpen: boolean
  label: string
  placeholder: string
  options: OptionI[]
  defaultValue?: any
}

export const EmailInputSelectControl = ({
  control,
  id,
  isLoading,
  isOpen,
  label,
  options,
  placeholder,
  defaultValue = null,
  ...rest
}: EmailInputSelectControlIProps) => {
  return (
    <Collapse in={isOpen}>
      <Box mb={6}>
        <FormInputSelectControl
          canCreateOption
          closeMenuOnSelect={false}
          control={control}
          defaultValue={defaultValue}
          dropdownContainerHeight='200px'
          formatCreateLabel={(name: string) => name}
          id={id}
          isClearable
          isLoading={isLoading}
          isMulti
          isSearchable
          isValidNewOption={(name: string) => EmailValidator.validate(name)}
          label={label}
          labelColour='#1A202C'
          labelFontWeight='600'
          labelOpacity={1}
          noOptionsMessage={() => 'Enter a valid email to create a Recipient'}
          options={options}
          placeholder={placeholder}
          {...rest}
        />
      </Box>
    </Collapse>
  )
}
